function removeNonNumCharacters(input: string) {
  return input.replace(/\D/g, '');
}

export const toNum: React.FormEventHandler<HTMLInputElement> = (e) => {
  const target = e.target as HTMLInputElement;
  target.value = target.value ? removeNonNumCharacters(target.value) : '';
};
